import { isLikelyIosDevice } from 'utils/isLikelyIosDevice';
import { isClinicalHud2ProductPath } from 'features/clinicalHud/marketing/clinicalHudMarketingRouting';

/**
 * localStorage CLINICALHUD2_IOS=1 previews the iPhone/iPad HUD2 chrome on any device.
 */
export const CLINICALHUD2_IOS_PREVIEW_KEY = 'CLINICALHUD2_IOS';

export function isClinicalHud2IosPreviewEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem(CLINICALHUD2_IOS_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
}

export function isClinicalHud2IosLayoutEnabled() {
  return isClinicalHud2IosPreviewEnabled() || isLikelyIosDevice();
}

export function shouldHideGlobalTopBarForHud2(pathname) {
  return (
    isClinicalHud2IosLayoutEnabled() && isClinicalHud2ProductPath(pathname)
  );
}

export function useClinicalHud2IosLayout() {
  return isClinicalHud2IosLayoutEnabled();
}

/**
 * Voice enrollment uses getUserMedia + Web Audio, which on iPhone/iPad steals
 * the mic from webkitSpeechRecognition and often fails after the tap gesture.
 * Skip it whenever the iOS HUD is showing, the device is iOS, or the pointer is coarse.
 */
export function shouldSkipHud2VoiceEnrollment() {
  if (isClinicalHud2IosLayoutEnabled()) return true;
  if (isLikelyIosDevice()) return true;
  if (typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)')?.matches) {
    return true;
  }
  return false;
}
